
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0a294a","d":"M12.257 3.278l5.364 4.097 1.757-2.317.062-.09a1.239 1.239 0 00-.297-1.65L15.759.73l-.076-.053a1.25 1.25 0 00-1.67.288zm1.57 6.221v-.022l.055.045a.647.647 0 01.07.858L7.89 18.34l-.047.055a.643.643 0 01-.857.064.636.636 0 01-.12-.898l6.063-7.937.045-.054a.643.643 0 01.853-.07zm-11.464 8.1l1.96 1.492 2.056 1.558.025.025a.167.167 0 01-.075.263v-.022l-2.679 1.28-2.09-1.598.553-2.874.012-.04a.173.173 0 01.239-.085zm.354-1.836l-.084.113-.782 1.024a1.49 1.49 0 00-.28.654l-.92 4.598-.012.096c-.04.442.16.877.527 1.134a1.18 1.18 0 001.21.076l4.261-1.9.064-.038c.425-.289 1.224-1.426 1.397-1.649l8.494-11.158-5.365-4.097z"}})])
          )
        }
      }
    